import React from 'react';

export default function ImageUploadHint({ style = {} }) {
  return (
    <div
      style={{
        fontSize: '11px',
        color: '#888',
        marginTop: '4px',
        lineHeight: 1.3,
        ...style,
      }}
    >
      Рекомендуем квадратное, мин. 500×500px. Автосжатие до WebP.
    </div>
  );
}
